import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet-async';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import StockPage from './pages/StockPage';
import PortfolioPage from './pages/PortfolioPage';
import Search from './pages/Search';
import ValueInvesting from './pages/content_pages/ValueInvesting';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Header from './components/Header';
import Footer from './components/Footer';
import Impressum from './components/Impressum';
import { AuthProvider } from './context/AuthContext';
import SearchExplanation from './pages/content_pages/SearchExplanation';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="flex flex-col min-h-screen">
            <Helmet>
              <title>DynaStoxx</title>
              <meta name="description" content="DynaStoxx - Track your favorite stocks" />
              <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
              <meta name="theme-color" content="#0f172a" />
              <meta name="robots" content="index, follow" />
              <link rel="canonical" href="https://dynastoxx.com" />
              <meta property="og:title" content="DynaStoxx" />
              <meta property="og:description" content="Track your favorite stocks" />
              <meta property="og:type" content="website" />
            </Helmet>
            <Header />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/stock-detail/:id" element={<StockPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/value-investing" element={<ValueInvesting />} />
                <Route path="/search" element={<Search />} />
                <Route path="/search-explained" element={<SearchExplanation/>} />
                <Route path="/articles" element={<Articles />} />
                <Route path="/articles/:slug" element={<ArticleDetail />} />
                <Route path="/impressum" element={<Impressum />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;